/**
 * Default endpoint limit for paginated API responses.
 * Used as a fallback when meta.counters.endpoint_limit is not provided.
 */
export const DEFAULT_ENDPOINT_LIMIT = 100000;
